"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onInputFocus = onInputFocus;
exports.onInputBlur = onInputBlur;
exports.onDatePickerChange = onDatePickerChange;
function onInputFocus(element) {
    var parent = element.closest('.md-input');
    parent.classList.remove("error");
    parent.classList.add("active");
}
function onInputBlur(element) {
    var parent = element.closest('.md-input');
    parent.classList.remove("active");
    if (element.value.trim() != "") {
        parent.classList.add("filled");
    } else {
        parent.classList.remove("filled");
    }
    if (!element.checkValidity()) {
        parent.classList.add("error");
    } else {
        parent.classList.remove("error");
    }
}

function onDatePickerChange(value) {
    var parent = document.querySelector('.md-datePicker');
    var input = parent.querySelector('input');
    parent.classList.remove("active");

    if (value && !value.target) {
        parent.classList.add("filled");
    } else {
        parent.classList.remove("filled");
    }

    if (value === "") {
        parent.classList.add("error");
    } else {
        parent.classList.remove("error");
    }
}